function twoDigits(value: number) {
  return value.toString().padStart(2, '0');
}

/**
 * Inserts the date and time before the extension, e.g. `Cut Sheet.pdf` -> `Cut Sheet 2026-08-24 143005.pdf`. This
 * matches how the server names downloads for organizations that ask for it, UTC included; use it only for files the
 * client builds itself, which the server never gets a chance to name.
 */
export function appendDateAndTimeToFileName(fileName: string, now = new Date()) {
  const date = `${now.getUTCFullYear()}-${twoDigits(now.getUTCMonth() + 1)}-${twoDigits(now.getUTCDate())}`;
  const time = `${twoDigits(now.getUTCHours())}${twoDigits(now.getUTCMinutes())}${twoDigits(now.getUTCSeconds())}`;

  const lastDotIndex = fileName.lastIndexOf('.');
  const extensionIndex = lastDotIndex === -1 ? fileName.length : lastDotIndex;

  return `${fileName.substring(0, extensionIndex)} ${date} ${time}${fileName.substring(extensionIndex)}`;
}
